import { FC, useCallback } from 'react'

import { useTranslation } from '../../../../hooks/locale'
import { useInstantBookingBanner } from '../hooks'
import { ThunderIcon } from '../../../common/icons'
import {
    BannerContainer,
    BannerLeft,
    ThunderIconCircle,
    BannerTextGroup,
    BannerLabel,
    BannerDescription,
    BannerSkeleton,
    ToggleSwitchButton,
    ToggleSwitchTrack,
    ToggleSwitchThumb,
} from './styles'
import AnalyticsService from '../../../../services/analytics-service'
import { searchResultListingsPageEventCategories } from '../../../../services/analytics-service/categories'

const InstantBookingBanner: FC = () => {
    const { t } = useTranslation()
    const { item, isChecked, isLoading, onToggle } = useInstantBookingBanner()

    const handleToggle = useCallback(() => {
        AnalyticsService.trackClickEvent(
            searchResultListingsPageEventCategories.instantBookingBannerSection.TOGGLE,
            isChecked ? 'off' : 'on',
        )
        onToggle()
    }, [isChecked, onToggle])

    if (isLoading && !item) {
        return <BannerSkeleton />
    }

    if (!item) {
        return null
    }

    return (
        <BannerContainer>
            <BannerLeft>
                <ThunderIconCircle>
                    <ThunderIcon width="16px" height="16px" />
                </ThunderIconCircle>
                <BannerTextGroup>
                    <BannerLabel>{item.title}</BannerLabel>
                    <BannerDescription>{t('instantBookingBanner.description')}</BannerDescription>
                </BannerTextGroup>
            </BannerLeft>
            <ToggleSwitchButton
                role="switch"
                aria-checked={isChecked}
                aria-label={item.title}
                onClick={handleToggle}
                disabled={isLoading}
                $isChecked={isChecked}
            >
                <ToggleSwitchTrack $isChecked={isChecked} />
                <ToggleSwitchThumb $isChecked={isChecked} />
            </ToggleSwitchButton>
        </BannerContainer>
    )
}

export default InstantBookingBanner
